import { Box, Spinner } from "@chakra-ui/react";
import { QueryStatus } from "@reduxjs/toolkit/query";

import { useAppSelector } from "../../../app/hooks";
import useDebounce from "../../../lib/useDebounce";

type X = {
  queries?: Record<string, { status: QueryStatus } | undefined>;
  mutations?: Record<string, { status: QueryStatus } | undefined>;
};
type S = Record<string, X>;

export const GlobalLoadingBar = () => {
  const loading = useAppSelector(s => {
    return Object.values(s as unknown as S)
      .flatMap(x => {
        let r: ({ status: QueryStatus } | undefined)[] = [];
        if (x.queries) r = [...r, ...Object.values(x.queries)];
        if (x.mutations) r = [...r, ...Object.values(x.mutations)];
        return r;
      })
      .some(q => q?.status === QueryStatus.pending);
  });

  const debounced = useDebounce(loading, 10);

  if (!debounced) return null;

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      zIndex={9999}
      bg="rgba(0, 0, 0, 0.3)"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Spinner size="xl" color="blue.500" />
    </Box>
  );
};
